/* eslint-disable @typescript-eslint/no-explicit-any */
import { BrandModel } from "../../Utils/Models";
import { useEffect, useRef, useState } from "react";
import AddOrUpdateModel from "../GenericComponents/AddOrUpdateModel";
import { Vocabulary } from "../../Utils/Vocabulary";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { Grid } from "@mui/material";
import { onChangeTextField } from "../../Utils/Utils";

type BrandProps = {
  editBrand: BrandModel | null;
  open: boolean;
  addOrUpdateBrand: (brand: BrandModel | null) => void;
  onClose: () => void;
};

export default function Brand(props: BrandProps) {
  const { editBrand, open, addOrUpdateBrand, onClose } = props;
  const ref: any = useRef();
  const [brand, setBrand] = useState<BrandModel>(new BrandModel());
  const [pressOnSubmit, setPressOnSubmit] = useState(false);

  /**
   *
   */
  useEffect(() => {
    if (editBrand) {
      setBrand(editBrand);
    } else {
      setBrand(new BrandModel());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editBrand]);

  /**
   *
   */
  useEffect(() => {
    if (pressOnSubmit) {
      ref.current.submit();
      //reset the value
      handleChangePressOnSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pressOnSubmit]);

  /**
   *
   */
  function handleChangePressOnSubmit() {
    setPressOnSubmit(!pressOnSubmit);
  }

  return (
    <ValidatorForm ref={ref} onSubmit={() => addOrUpdateBrand(brand)}>
      <AddOrUpdateModel
        open={open}
        title={Vocabulary.brand}
        onClose={onClose}
        isSubmit={true}
        addOrUpdateItem={() => null}
        handleChangePressOnSubmit={handleChangePressOnSubmit}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <TextValidator
              size="small"
              id="name"
              name="name"
              label={Vocabulary.name}
              fullWidth
              variant="outlined"
              value={brand.name}
              validators={["required"]}
              errorMessages={[Vocabulary.requiredField]}
              onChange={(event: any) =>
                setBrand(onChangeTextField(event, brand))
              }
            />
          </Grid>
        </Grid>
      </AddOrUpdateModel>
    </ValidatorForm>
  );
}
